import styled, { css } from 'styled-components';
import {
  FlexDirectionProps,
  GridProps,
  MarginProps,
  flexDirection,
  grid,
  margin,
} from 'styled-system';

export const Row = styled.div<FlexDirectionProps & GridProps>`
  display: flex;

  ${flexDirection};
  ${grid};
`;

export const Separator = styled.div<MarginProps>`
  width: 1px;
  flex-shrink: 0;

  ${margin};
  ${({ theme }) =>
    css`
      background-color: ${theme.colors.gray.extraLight};
    `};
`;
